import _Spin from "hzero-ui/lib/spin";
import React, { forwardRef, useContext, useMemo } from "react";
import { ThemeContext, isEmpty, getStyleSheetTarget, getThemeData, EUedThemeName } from "@hzero-front-ui/core";
import styled, { keyframes, StyleSheetManager } from "styled-components";
import "./css";
function getOffset(length, index) {
  var step = 100 / (length - 1);
  return "".concat(step * index, "%");
}
var getLoading = function getLoading(props) {
  var circleSize = props.circleSize;
  return keyframes(["0%{stroke-dasharray:0 ", ";stroke-dashoffset:0;transform:rotateZ(-90deg);}50%{stroke-dasharray:", " ", ";stroke-dashoffset:0;}99.9%{stroke-dasharray:", " ", ";stroke-dashoffset:-", ";}100%{stroke-dasharray:0 ", ";stroke-dashoffset:0;transform:rotateZ(270deg);};"], circleSize, circleSize, circleSize, circleSize, circleSize, circleSize, circleSize);
};
var Svg = styled.svg.withConfig({
  displayName: "Spin__Svg",
  componentId: "sc-fgi1an-0"
})(["position:absolute !important;top:50% !important;left:50% !important;transform:translate(-50%,-50%) !important;width:", "px !important;height:", "px !important;#hzero-loading-circle{stroke-width:4;stroke-dasharray:0 ", ";fill:", ";stroke:url(#hzero-ui-loading-circle-gradient);animation:", " cubic-bezier(0.62,0.24,0.59,0.93) 1.6s infinite;transform-origin:center;}"], function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.circleSize;
}, function (props) {
  return getThemeData(props, "spin", "fillColor") || "rgba(0,0,0,0)";
}, function (props) {
  return getLoading(props);
});
export var LoadingCircle = function LoadingCircle(props) {
  var _useContext = useContext(ThemeContext),
    _useContext$originThe = _useContext.originTheme,
    originTheme = _useContext$originThe === void 0 ? {} : _useContext$originThe;
  var _originTheme$spin = originTheme.spin,
    spin = _originTheme$spin === void 0 ? {} : _originTheme$spin;
  var size = spin.size || 50;
  var stopsArray = spin.circleColorGradient || [];
  return /*#__PURE__*/React.createElement(Svg, Object.assign({
    width: size,
    height: size,
    size: size,
    circleSize: (size - 8) * 3.14,
    className: "ant-spin-dot"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hzero-ui-loading-circle-gradient",
    x1: "0",
    x2: "0",
    y1: "0",
    y2: "1"
  }, stopsArray.map(function (s, i) {
    return /*#__PURE__*/React.createElement("stop", {
      // key={`${s}${i}`}
      offset: getOffset(stopsArray.length, i),
      stopColor: s
    });
  })), /*#__PURE__*/React.createElement("circle", {
    cx: size / 2,
    cy: size / 2,
    r: size / 2 - 4,
    id: "hzero-loading-circle"
  }));
}; // 还原孔雀蓝原图标效果

var c7nRotate = function c7nRotate() {
  return keyframes(["to{transform:rotate(360deg);}"]);
};
var IndictorPointOfThemeTwo = styled.span.withConfig({
  displayName: "Spin__IndictorPointOfThemeTwo",
  componentId: "sc-fgi1an-1"
})(["position:relative;display:inline-block;font-size:20px;width:20px;height:20px;animation:", " 1s linear infinite;span{width:9px;height:9px;border-radius:100%;background-color:#29bece;transform:scale(0.75);display:block;position:absolute;transform-origin:50% 50%;margin:0 !important;padding:0 !important;}span:nth-child(1){left:0;top:0;}span:nth-child(2){right:0;top:0;opacity:0.4;}span:nth-child(3){right:0;bottom:0;opacity:0.6;}span:nth-child(4){left:0;bottom:0;opacity:0.8;}"], c7nRotate);
var indicatorcOfTheme2 = /*#__PURE__*/React.createElement(IndictorPointOfThemeTwo, {
  className: "custom-spin-dot"
}, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null));
export function useLoadingEl() {
  var _useContext2 = useContext(ThemeContext),
    schema = _useContext2.schema,
    _useContext2$resolved = _useContext2.resolvedTheme,
    resolvedTheme = _useContext2$resolved === void 0 ? {} : _useContext2$resolved;
  var _resolvedTheme$spin = resolvedTheme.spin,
    spin = _resolvedTheme$spin === void 0 ? {} : _resolvedTheme$spin;
  var currentTheme = resolvedTheme.__uedThemeName__;
  var type = spin.type || "dot"; // dot || circle

  return useMemo(function () {
    if (currentTheme === EUedThemeName.theme2) {
      return indicatorcOfTheme2;
    }
    return type === "circle" && !isEmpty(schema, resolvedTheme) ? /*#__PURE__*/React.createElement(LoadingCircle, null) : undefined;
  }, [currentTheme, type, schema, resolvedTheme]);
}
var Spin = forwardRef(function (props, ref) {
  var indicator = useLoadingEl();
  return /*#__PURE__*/React.createElement(StyleSheetManager, {
    target: getStyleSheetTarget("UED_HZERO_UI_OVERRIDE_INJECTION_SPIN")
  }, /*#__PURE__*/React.createElement(_Spin, Object.assign({}, props, {
    ref: ref,
    indicator: props.indicator || indicator
  })));
});
export default Object.assign(Spin, _Spin);